import { Button, ButtonProps } from '@mantine/core';

import classes from './index.module.css';

interface ICustomButton extends ButtonProps {
  children: any;
  disabled?: boolean;
  header?: boolean;
  onClick?: () => void;
  secondary?: boolean;
  type?: 'submit' | 'reset' | 'button';
}

const BasicButton = ({
  children,
  disabled,
  header,
  onClick,
  secondary,
  type,
  ...props
}: ICustomButton) => {
  let btnClasses = `${classes.button}`
  if (secondary) btnClasses += ` ${classes.secondary}`
  else btnClasses += ` ${classes.primary}`;

  if (header) btnClasses += ` ${classes.header}`;
  if (disabled) btnClasses += ` ${classes.disabled}`;

  return (
    <Button
      className={btnClasses}
      variant={'filled'}
      onClick={onClick}
      type={type}
      disabled={disabled}
      {...props}
    >
      {children}
    </Button>
  );
}

export default BasicButton;